module.exports = __webpack_public_path__ + "media/images/waves-148ba8b9dd2845dc216e2858671cefa3.png";